import React from 'react'
import { View } from 'react-native'
import { useSelector } from 'react-redux';
import { LANDSCAPE } from '../../config/Constant';
import { useCssStyle } from '../../customHook/getCssStyle';
import { CustomModal } from '.';

const CustomModal_Right = (props) => {
    const { appOrientation } = useSelector(state => (state.appConfigSlice));

    const getStyles = useCssStyle();

    if (appOrientation == LANDSCAPE) {
        return <CustomModal 
            {...props} 
            slideFromRight 
            customInnerCompsStyleWeb={getStyles(["customModalInnerContainerWeb"])} 
            landscapeStyle={getStyles(["customModalInnerContainerRightLandscape"])} 
        />
    }
    return <CustomModal {...props} />
}

export default CustomModal_Right
